import ResizeIcon from "./ResizeIcon";
import Resize2Icon from "./Resize2Icon";
import MinimizeIcon from "./MinimizeIcon";
import ChatbotIcon from "./ChatbotIcon";
import HomeIcon from "./HomeIcon";
import ScheduleIcon from "./ScheduleIcon";
import CallIcon from "./CallIcon";
import FocusViewIcon from "./FocusViewIcon";
import BedroomIcon from "./BedroomIcon";
import ArrowIcon from "./ArrowIcon";
import ReloadIcon from "./ReloadIcon";
import GridViewIcon from "./GridViewIcon";
import ListViewIcon from "./ListViewIcon";
import MaleIcon from "./MaleIcon";
import VideoTourIcon from "./VideoTourIcon";
import EmailIcon from "./EmailIcon";
import PhoneIcon from "./PhoneIcon";
import SendIcon from "./SendIcon";
import ChevronIcon from "./ChevronIcon";
import FloorPlanPlaceholderIcon from "./FloorPlanPlaceholderIcon";
import Send2Icon from "./Send2Icon";
import CalendarIcon from "./CalendarIcon";
import CalTodayIcon from "./CalTodayIcon";
import TriggerNormalIcon from "./TriggerNormalIcon";
import TriggerHoveredIcon from "./TriggerHoveredIcon";
import PhotoIcon from "./PhotoIcon";
import CommunityIcon from "./CommunityIcon";
import VideoIcon from "./VideoIcon";
import SizeIcon from "./SizeIcon";
import VideoPlayIcon from "./VideoPlayIcon";
import TDTourPlayIcon from "./3DTourPlayIcon";
import StickyRightIcon from "./StickyRightIcon";
import PencilIcon from "./PencilIcon";
import ExternalLinkIcon from "./ExternalLinkIcon";
import FAQsIcon from "./FAQsIcon";
import WelcomeMessageIcon from "./WelcomeMessage";
import LikeIcon from "./LikeIcon";
import DisLikeIcon from "./DisLikeIcon";
import FlagIcon from "./FlagIcon";
import FeedBackIcon from "./FeedBackIcon";
import UpIcon from "./UpIcon";
import DownIcon from "./DownIcon";
import PlaceholderImageIcon from "./PlaceholderImage";
import BathroomIcon from "./BathroomIcon";
import TopArrowIcon from "./TopArrowIcon";
import OpenLinkIcon from "./OpenLinkIcon";
import { DefaultUserIcon } from "./DefaultUserIcon";
import { LeftArrowIcon } from "./LeftArrowIcon";
import { ExpandMoreIcon } from "./ExpandMoreIcon";
import DoubleCheck from "./DoubleCheck";
import InfoIcon from "./InfoIcon";
import BugIcon from "./BugIcon";
import MoreIcon from "./MoreIcon";
import LinearSend from "./LinearSend";
import SearchIcon from "./SearchIcon";
import ClockIcon from "./ClockIcon";
import ContactIcon from "./ContactIcon";
import ArrowDown from "./ArrowDown";
import CancelIcon from "./CancelIcon";
import CheckedCalendarIcon from "./CheckedCalendarIcon/index";
import LocationIcon from "./LocationIcon/index";
import PersonIcon from "./PersonIcon/index";
import GpsIcon from "./GpsIcon/index";

const Icon = ({ iconType, ...rest }) => {
  switch (iconType) {
    case "ArrowDown":
      return <ArrowDown {...rest} />;
    case "moreIcon":
      return <MoreIcon {...rest} />;
    case "search":
      return <SearchIcon {...rest} />;
    case "clock":
      return <ClockIcon {...rest} />;
    case "send":
      return <ContactIcon {...rest} />;
    case "linearSend":
      return <LinearSend {...rest} />;
    case "Resize":
      return <ResizeIcon {...rest} />;
    case "Resize2":
      return <Resize2Icon {...rest} />;
    case "Minimize":
      return <MinimizeIcon {...rest} />;
    case "Chatbot":
      return <ChatbotIcon {...rest} />;
    case "Home":
      return <HomeIcon {...rest} />;
    case "Schedule":
      return <ScheduleIcon {...rest} />;
    case "Call":
      return <CallIcon {...rest} />;
    case "FocusView":
      return <FocusViewIcon {...rest} />;
    case "Bedroom":
      return <BedroomIcon {...rest} />;
    case "Arrow":
      return <ArrowIcon {...rest} />;
    case "Reload":
      return <ReloadIcon {...rest} />;
    case "GridView":
      return <GridViewIcon {...rest} />;
    case "ListView":
      return <ListViewIcon {...rest} />;
    case "Male":
      return <MaleIcon {...rest} />;
    case "VideoTour":
      return <VideoTourIcon {...rest} />;
    case "Email":
      return <EmailIcon {...rest} />;
    case "Phone":
      return <PhoneIcon {...rest} />;
    case "Send":
      return <SendIcon {...rest} />;
    case "Chevron":
      return <ChevronIcon {...rest} />;
    case "FloorPlanPlaceholder":
      return <FloorPlanPlaceholderIcon {...rest} />;
    case "Send2":
      return <Send2Icon {...rest} />;
    case "Calendar":
      return <CalendarIcon {...rest} />;
    case "CalToday":
      return <CalTodayIcon {...rest} />;
    case "TriggerNormal":
      return <TriggerNormalIcon {...rest} />;
    case "TriggerHovered":
      return <TriggerHoveredIcon {...rest} />;
    case "Photo":
      return <PhotoIcon {...rest} />;
    case "Community":
      return <CommunityIcon {...rest} />;
    case "Video":
      return <VideoIcon {...rest} />;
    case "Size":
      return <SizeIcon {...rest} />;
    case "VideoPlay":
      return <VideoPlayIcon {...rest} />;
    case "3DTourPlay":
      return <TDTourPlayIcon {...rest} />;
    case "StickyRight":
      return <StickyRightIcon {...rest} />;
    case "Pencil":
      return <PencilIcon {...rest} />;
    case "ExternalLink":
      return <ExternalLinkIcon {...rest} />;
    case "FAQs":
      return <FAQsIcon {...rest} />;
    case "WelcomeMessage":
      return <WelcomeMessageIcon {...rest} />;
    case "like":
      return <LikeIcon {...rest} />;
    case "dislike":
      return <DisLikeIcon {...rest} />;
    case "Flag":
      return <FlagIcon {...rest} />;
    case "feedback":
      return <FeedBackIcon {...rest} />;
    case "up":
      return <UpIcon {...rest} />;
    case "down":
      return <DownIcon {...rest} />;
    case "PlaceholderImage":
      return <PlaceholderImageIcon {...rest} />;
    case "Bathroom":
      return <BathroomIcon {...rest} />;
    case "TopArrow":
      return <TopArrowIcon {...rest} />;
    case "OpenLinkIcon":
      return <OpenLinkIcon {...rest} />;
    case "DefaultUser":
      return <DefaultUserIcon {...rest} />;
    case "LeftArrow":
      return <LeftArrowIcon {...rest} />;
    case "ExpandMore":
      return <ExpandMoreIcon {...rest} />;
    case "BugIcon":
      return <BugIcon {...rest} />;
    case "DoubleCheckIcon":
      return <DoubleCheck {...rest} />;
    case "InfoIcon":
      return <InfoIcon {...rest} />;
    case "Cancel":
      return <CancelIcon {...rest} />;
    case "CheckedCalendar":
      return <CheckedCalendarIcon />;
    case "PersonIcon":
      return <PersonIcon />;
    case "locationPinIcon":
      return <LocationIcon />;
    case "gpsIcon":
      return <GpsIcon />;
    default:
      return <ChatbotIcon {...rest} />;
  }
};

export default Icon;
